import { toWorkspacePath } from "@/features/Workspaces/workspaceRoutes";
// Import of the module

import { ExternalLink } from "@/components/ExternalLink";
import i18n from "@/i18n";
import { Link } from "@heroui/link";
import { ColumnDef } from "@tanstack/react-table";

// Type of the fields in the table

export type B1Metadata = {
  id: number;
  owner_type: string;
  owner_id: number;
  owner_name?: string;
  field_key: string;
  field_value: string;
  created_at: string;
  updated_at: string;
};

// Definition of the columns

export const b1_metadata_columns: ColumnDef<B1Metadata>[] = [
  {
    accessorKey: "id",
    header: "Id",
  },
  {
    accessorKey: "owner_name",
    header: "Owner",
    cell: ({ row }) => {
      const ownerId = row.original.owner_id;
      const ownerName = row.original.owner_name;

      return (
        <ExternalLink
          href={toWorkspacePath(`/admin/b1-quantilia/strategies/${ownerId}`)}
          className="text-xs"
          underline="hover"
        >
          {ownerName}
        </ExternalLink>
      );
    },
  },
  {
    accessorKey: "field_key",
    header: "Field Key",
  },
  {
    accessorKey: "field_value",
    header: "Field Value",
  },
  {
    id: "actions",
    header: () => <div className="text-right">Actions</div>,
    cell: ({ row }) => {
      return (
        <div className="flex justify-end">
          <Link
            href={`${window.location.pathname}/${row.getValue("id")}`}
            className="text-xs"
            underline="hover"
          >
            {i18n.t("actions.edit")}
          </Link>
        </div>
      );
    },
  },
];
